<template>
    <v-dialog
        v-model="show"
        max-width="400"
        @click:outside="$emit('update:show', false)"
    >
        <v-card>
            <v-toolbar
                color="primary"
                dark
                flat
            >
                <v-toolbar-title>
                    Match Type
                </v-toolbar-title>
            </v-toolbar>

            <v-card-text class="subtitle-1 mt-3">
                <v-img
                    src="/images/partial_match_badge.png"
                />
                <p>
                    Partial match allows you to send desirable amounts less than the amount obtainable on the offer.
                </p>
                <v-img
                    src="/images/full_match_badge.png"
                />
                <p>
                    With full match, you can only send the exact amount displayed.
                </p>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        props: {
            show: {
                type: Boolean,
                required: true,
            },
        },
    };
</script>
